import React from "react";
import arrow from "../assets/images/head4.png";
import img1 from "../assets/images/background-certificate.jpg";
import img2 from "../assets/images/foodsafety-logo.jpg";
import img3 from "../assets/images/fssai-logo.png";
import img4 from "../assets/images/halal-logo.png";
import img5 from "../assets/images/intertek-logo.jpg";

const Certification = () => {
  return (
    <div className="main-div">
      <img src={img1} className="main-img" />
      <div className="div-wrapper">
        <div className="div-wrapper-inner">
          <img src={arrow} className="arrow_img mt ml" />
          <p className="mt">
            We at Big Drum India believe we have closely adhered to the
            guidelines prescribed by Codex Alimentarius Commission & the BSI, as
            we believe in producing quality products. Big Drum India Pvt Ltd is
            the proud owner of these certifications.
          </p>
        </div>
      </div>
      <div className="w100 db flex">
        <div className="img-text-row">
          <img src={img2} className="small-logo" />
          <div className="w60">
            <h4 className="red mv20">FOOD SAFETY SYSTEM CERTIFICATION 22000</h4>
            <p>
              FSSC 22000 is the world's leading, independently managed,
              nonprofit food certification scheme for ISO 22000-based
              certification of food safety management systems.. Big Drum India
              Pvt Ltd’s food safety management system has been assessed and
              registered by Intertek Certification AB as Conforming to the
              requirements of FSSC 22000:2010.
            </p>
          </div>
          <img src={img5} className="small-logo" />
        </div>
        <div className="img-text-row mv">
          <img src={img3} className="small-logo" />
          <div className="w60">
            <h4 className="red mv20">FOOD SAFETY SYSTEM CERTIFICATION 22000</h4>
            <p>
              FSSC 22000 is the world's leading, independently managed,
              nonprofit food certification scheme for ISO 22000-based
              certification of food safety management systems.. Big Drum India
              Pvt Ltd’s food safety management system has been assessed and
              registered by Intertek Certification AB as Conforming to the
              requirements of FSSC 22000:2010.
            </p>
          </div>
          <div style={{ width: "120px" }}></div>
        </div>
        <div className="img-text-row mb">
          <img src={img4} className="small-logo" />
          <div className="w60">
            <h4 className="red mv20">FOOD SAFETY SYSTEM CERTIFICATION 22000</h4>
            <p>
              FSSC 22000 is the world's leading, independently managed,
              nonprofit food certification scheme for ISO 22000-based
              certification of food safety management systems.. Big Drum India
              Pvt Ltd’s food safety management system has been assessed and
              registered by Intertek Certification AB as Conforming to the
              requirements of FSSC 22000:2010.
            </p>
          </div>
          <div style={{ width: "120px" }}></div>
        </div>
      </div>
    </div>
  );
};

export default Certification;
// <>
//     <Container maxW={"full"} h={"65%"} p={0}>
//       <Image src={img1} w={"full"} objectFit={"cover"} />
//     </Container>
//     <Container maxW={"78%"}>
//       <Image
//         src={arrow}
//         h={"24"}
//         objectFit={"contain"}
//         pt={5}
//         pb={4}
//         ml={"7"}
//       />
//       <Text fontSize={"13px"} lineHeight={"6"}>
//         We at Big Drum India believe we have closely adhered to the guidelines
//         prescribed by Codex Alimentarius Commission & the BSI, as we believe
//         in producing quality products. Big Drum India Pvt Ltd is the proud
//         owner of these certifications.
//       </Text>
//     </Container>
//     <Container maxW={"90%"} mb={10}>
//       <Flex mt={10}>
//         <Image src={img2} w={"150px"} objectFit={"contain"} />
//         <VStack align={"flex-start"} marginInline={"6%"}>
//           <Text fontSize={"md"} fontWeight={"bold"} color={"#e91b23"}>
//             FOOD SAFETY SYSTEM CERTIFICATION 22000
//           </Text>
//           <Text fontSize={"xs"} lineHeight={"6"}>
//             FSSC 22000 is the world's leading, independently managed,
//             nonprofit food certification scheme for ISO 22000-based
//             certification of food safety management systems.. Big Drum India
//             Pvt Ltd’s food safety management system has been assessed and
//             registered by Intertek Certification AB as Conforming to the
//             requirements of FSSC 22000:2010.
//           </Text>
//         </VStack>
//         <Image src={img2} w={"150px"} objectFit={"contain"} />
//       </Flex>
//       <Flex mt={10}>
//         <Image src={img3} w={"150px"} objectFit={"contain"} />
//         <VStack align={"flex-start"} marginInline={"6%"}>
//           <Text fontSize={"md"} fontWeight={"bold"} color={"#e91b23"}>
//             FSSAI
//           </Text>
//           <Text fontSize={"xs"} lineHeight={"6"}>
//             Food Safety and Standards Authority of India is an autonomous body
//             established under the Ministry of Health & Family Welfare,
//             Government of India.
//           </Text>
//         </VStack>
//         <Stack w={"10%"} />
//       </Flex>
//       <Flex mt={10}>
//         <Image src={img4} w={"150px"} objectFit={"contain"} />
//         <VStack align={"flex-start"} marginInline={"6%"}>
//           <Text fontSize={"md"} fontWeight={"bold"} color={"#e91b23"}>
//             HALAL INDIA CERTIFICATE
//           </Text>
//           <Text fontSize={"xs"} lineHeight={"6"}>
//             Halal India certifies that the Wafer Biscuit Cone is “Halal” in
//             accordance with Shariah (Islamic) Board Guidelines.
//           </Text>
//         </VStack>
//         <Stack w={"10%"} />
//       </Flex>
//     </Container>
//   </>
